import { inject, Injectable } from "@angular/core";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { filter } from "rxjs";

@Injectable({ providedIn: "root" })
export class UpdateService {
    private swUpdate = inject(SwUpdate);

    constructor() {
        this.setupUpdateListener();
        void this.checkForUpdate();
    }

    private setupUpdateListener() {
        if (!this.swUpdate.isEnabled) return;

        this.swUpdate.versionUpdates
            .pipe(
                filter(
                    (evt): evt is VersionReadyEvent =>
                        evt.type === "VERSION_READY",
                ),
            )
            .subscribe((evt) => {
                this.activateUpdate();
            });
    }

    private async checkForUpdate(): Promise<void> {
        if (!this.swUpdate.isEnabled) return;

        try {
            await this.swUpdate.checkForUpdate();
        } catch (error) {
            console.warn("Failed to check for a service worker update.", error);
        }
    }

    private activateUpdate() {
        window.location.reload();
    }
}
